import pWaitFor from "p-wait-for";

export function getWorkoutItemElementId(workoutItemId: string) {
  return `workout-item-${workoutItemId}`;
}

interface ScrollWorkoutItemIntoViewInput {
  workoutItemId: string;
  block?: ScrollLogicalPosition;
  behavior?: ScrollBehavior;
}

function waitForWorkoutItemElement(
  workoutItemId: string,
): Promise<HTMLElement | null> {
  return pWaitFor(
    () => {
      const element = document.getElementById(
        getWorkoutItemElementId(workoutItemId),
      );

      if (element === null) {
        return false;
      }

      return pWaitFor.resolveWith(element);
    },
    {
      interval: 20,
      timeout: 1000,
    },
  ).catch(() => {
    return null;
  });
}

export async function scrollWorkoutItemIntoView(
  input: ScrollWorkoutItemIntoViewInput,
) {
  const element = await waitForWorkoutItemElement(input.workoutItemId);

  if (element === null) {
    return;
  }

  element.scrollIntoView({
    behavior: input.behavior ?? "smooth",
    block: input.block ?? "center",
  });
}
